import { z } from 'zod'
import {
  STRATALYST_PROJECT_MODULES_READ_CONTRACT_VERSION,
  stratalystProjectModuleSummarySchema,
  stratalystProjectModulesReadSideEffectsSchema,
} from './stratalyst-project-modules-read'

export const STRATALYST_PROJECT_MODULES_WRITE_CONTRACT_VERSION = STRATALYST_PROJECT_MODULES_READ_CONTRACT_VERSION

/** The route keeps module-id validation and error precedence in the handler. */
export const stratalystProjectModulesSetRequestSchema = z.object({
  module_ids: z.unknown().optional(),
}).passthrough()

export const stratalystProjectModulesSetResponseSchema = z.object({
  contract_version: z.literal(STRATALYST_PROJECT_MODULES_WRITE_CONTRACT_VERSION),
  modules: z.array(stratalystProjectModuleSummarySchema),
  replayed: z.boolean(),
  sideEffects: stratalystProjectModulesReadSideEffectsSchema,
}).passthrough()

export type StratalystProjectModulesSetRequest = z.infer<typeof stratalystProjectModulesSetRequestSchema>
export type StratalystProjectModulesSetResponse = z.infer<typeof stratalystProjectModulesSetResponseSchema>
